import { useEffect, useState } from 'react';
import CharacterCounter from '../character-counter';

const CharacterCounterSlate = ({ editor, characterLimit }) => {
    const [charCount, setCharCount] = useState(0);

    useEffect(() => {
        const updateCharCount = () => {
            const text = editor.children
                .map((n) => n.children.map((t) => t.text).join(''))
                .join('');
            setCharCount(text.length);
        };

        const { onChange } = editor;
        editor.onChange = () => {
            onChange();
            updateCharCount();
        };

        updateCharCount();
    }, [editor]);

    return (
        <CharacterCounter
            charCount={charCount}
            characterLimit={characterLimit}
        />
    );
};
export default CharacterCounterSlate;
